var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.categories.length === 0)?_c('b-spinner',{attrs:{"small":""}}):_c('span',{class:{'text-danger text-bold': !_vm.categoryName }},[_vm._v(" "+_vm._s(_vm.categoryName || 'Aucune catégorie')+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }